import React from 'react';
import { ZIndex } from '@osmosis/tailwind-ui/helpers/zIndex';
import RotatingIcon from '../RotatingIcon';
import { Button, ButtonProps } from '@osmosis/tailwind-ui/components/Button';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { dashboardSearchTopics, text5 } from '@osmosis/tailwind-ui/styles';
import { useContentSize } from '@osmosis/nextjs-components/context';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

type Props = ButtonProps & {
  isVisible: boolean;
  'data-testid'?: string;
};

/**
 * WelcomeHeaderDropdownButton.
 */
const WelcomeHeaderDropdownButton = React.forwardRef<HTMLButtonElement, Props>(
  (props, ref) => {
    const { isVisible, ...rest } = props;

    const { getClassValue } = useContentSize();

    const responsiveContainerClassname = getClassValue({
      defaultClasses: 'sm:w-[162px]',
      breakpoints: { sm: 'w-[162px]' },
    });

    return (
      <Button
        ref={ref}
        data-testid={props['data-testid']}
        cn={cn(
          dashboardSearchTopics,
          `w-full h-[55px] justify-center z-[${ZIndex.BASE}] rounded-[8px] border-1`,
          responsiveContainerClassname,
        )}
        {...rest}
      >
        <Box cn={`rounded-md ${text5} flex items-center whitespace-nowrap`}>
          {props.children}
          <Box cn={`${text5} ml-2`}>
            <RotatingIcon isRotated={isVisible} />
          </Box>
        </Box>
      </Button>
    );
  },
);

WelcomeHeaderDropdownButton.displayName = 'WelcomeHeaderDropdownButton';

export default WelcomeHeaderDropdownButton;
